import { __decorate } from "tslib";
import { Mixins, Component, Prop, Inject } from 'vue-property-decorator';
import ShopifySyncingProgress from '@/plugins/graphql/subscriptions/v3/shopify-syncing-progress.gql';
import ShopifySyncingStatus from '@/plugins/graphql/queries/v3/shopify-syncing-status.gql';
import AlertMixin from '@/helpers/vue_mixins/AlertMixin';
let ShopifyProgressBar = class ShopifyProgressBar extends Mixins(AlertMixin) {
    constructor() {
        super(...arguments);
        this.productSyncStatus = {
            syncing: false,
            progress: 0,
        };
        this.shippingRateSyncStatus = {
            syncing: false,
            progress: 0,
        };
        this.promoCodeSyncStatus = {
            syncing: false,
            progress: 0,
        };
        this.text = '';
        this.percentage = 0;
        this.syncingCount = 0;
        this.progressTotal = 0;
        this.initialized = false;
    }
};
__decorate([
    Inject()
], ShopifyProgressBar.prototype, "updateProductSyncStatus", void 0);
__decorate([
    Inject()
], ShopifyProgressBar.prototype, "updateShippingRateSyncStatus", void 0);
__decorate([
    Inject()
], ShopifyProgressBar.prototype, "updatePromoCodeSyncStatus", void 0);
__decorate([
    Prop()
], ShopifyProgressBar.prototype, "appUuid", void 0);
__decorate([
    Prop()
], ShopifyProgressBar.prototype, "appGlobalId", void 0);
ShopifyProgressBar = __decorate([
    Component({
        apollo: {
            initialized: {
                query: ShopifySyncingStatus,
                variables() {
                    return {
                        appUuid: this.appUuid,
                    };
                },
                update(data) {
                    const { shopifyProductSyncing, shopifyShippingRatesSyncing, shopifyPromoCodeSyncing, } = data.fetchAppByUuid;
                    // Blocks refetching of sync status
                    // Status should be updated through subscription
                    if (this.initialized)
                        return true;
                    // Initial text while waiting for percentage update
                    this.text = '';
                    if (shopifyProductSyncing) {
                        this.text = 'Products';
                    }
                    if (shopifyShippingRatesSyncing) {
                        this.text += this.text ? ', Shipping Rates' : 'Shipping Rates';
                    }
                    if (shopifyPromoCodeSyncing) {
                        this.text += this.text ? ', Promo Codes' : 'Promo Codes';
                    }
                    this.text += this.text ? ' are syncing...' : '';
                    this.updateProductSyncStatus(shopifyProductSyncing);
                    this.updateShippingRateSyncStatus(shopifyShippingRatesSyncing);
                    this.updatePromoCodeSyncStatus(shopifyPromoCodeSyncing);
                    return true;
                },
                subscribeToMore: {
                    document: ShopifySyncingProgress,
                    variables() {
                        return {
                            appGlobalId: this.appGlobalId,
                        };
                    },
                    updateQuery(previousResult, { subscriptionData }) {
                        const { productProgress, shippingRateProgress, promoCodeProgress, productSyncing, shippingRateSyncing, promoCodeSyncing, } = subscriptionData.data.shopifySyncingProgress;
                        if (!productSyncing && productProgress === 100) {
                            this.updateProductSyncStatus(false);
                            this.productSyncStatus.syncing = false;
                            this.productSyncStatus.progress = 0;
                            this.successNotification('Products Synced Successfully');
                        }
                        else if (!shippingRateSyncing && shippingRateProgress === 100) {
                            this.updateShippingRateSyncStatus(false);
                            this.shippingRateSyncStatus.syncing = false;
                            this.shippingRateSyncStatus.progress = 0;
                            this.successNotification('Shipping Rates Synced Successfully');
                        }
                        else if (!promoCodeSyncing && promoCodeProgress === 100) {
                            this.updatePromoCodeSyncStatus(false);
                            this.promoCodeSyncStatus.syncing = false;
                            this.promoCodeSyncStatus.progress = 0;
                            this.successNotification('Promo Codes Synced Successfully');
                        }
                        else if (productSyncing && productProgress > -1) {
                            this.updateProductSyncStatus(productSyncing);
                            this.productSyncStatus.syncing = productSyncing;
                            this.productSyncStatus.progress = productProgress;
                        }
                        else if (shippingRateSyncing && shippingRateProgress > -1) {
                            this.updateShippingRateSyncStatus(shippingRateSyncing);
                            this.shippingRateSyncStatus.syncing = shippingRateSyncing;
                            this.shippingRateSyncStatus.progress = shippingRateProgress;
                        }
                        else if (promoCodeSyncing && promoCodeProgress > -1) {
                            this.updatePromoCodeSyncStatus(promoCodeSyncing);
                            this.promoCodeSyncStatus.syncing = promoCodeSyncing;
                            this.promoCodeSyncStatus.progress = promoCodeProgress;
                        }
                        this.syncingCount = 0;
                        this.progressTotal = 0;
                        this.percentage = 0;
                        this.text = '';
                        if (this.productSyncStatus.syncing) {
                            this.syncingCount += 1;
                            this.progressTotal += this.productSyncStatus.progress;
                            this.text = 'Products';
                        }
                        if (this.shippingRateSyncStatus.syncing) {
                            this.syncingCount += 1;
                            this.progressTotal += this.shippingRateSyncStatus.progress;
                            this.text += this.text ? ', Shipping Rates' : 'Shipping Rates';
                        }
                        if (this.promoCodeSyncStatus.syncing) {
                            this.syncingCount += 1;
                            this.progressTotal += this.promoCodeSyncStatus.progress;
                            this.text += this.text ? ', Promo Codes' : 'Promo Codes';
                        }
                        if (this.syncingCount > 0) {
                            this.percentage = Math.ceil(this.progressTotal / this.syncingCount);
                            this.text += ` are syncing... ${this.percentage}%`;
                        }
                        return previousResult;
                    },
                },
            },
        },
    })
], ShopifyProgressBar);
export default ShopifyProgressBar;
